import CartButton from '@/features/home/Flash_sales/components/CartButton';
import NextImage from '@/features/Image';
import { sliceRoute } from '@/utils/sliceRoute';
import Link from 'next/link';
import { FaStar } from 'react-icons/fa6';

const ProductListingCard = ({
  title,
  products,
  categoryUrl,
}: {
  title: string;
  products: any;
  categoryUrl: string;
}) => {
  return (
    <div className="row g-3">
      <div className="col-12">
        <div className="product-listing__title ">
          <h3 className="fw-medium mb-0">{title}</h3>
        </div>
      </div>
      {products.map((product: any, i: number) => (
        <div className="col-12" key={i}>
          <div className="product__item product__item--style3">
            <div className=" product__item-inner">
              {product.badge && (
                <div className="product__item-badge">{product.badge}</div>
              )}
              <div
                className="product__item-thumb"
                style={{ maxWidth: '128px' }}
              >
                <NextImage
                  width={116}
                  height={118}
                  src={product?.pictures?.[0]?.url}
                  alt={product.title || 'Product Image'}
                />
              </div>
              <div className="product__item-content">
                <h5 className="fw-semibold">
                  <Link href={`/product/${product?.slug}`}>
                    {product?.name || product.title}
                  </Link>
                </h5>
                <div className="product__item-rating">
                  <FaStar /> {product?.ratings || product.rating}{' '}
                  <span>({product?.reviews})</span>
                </div>
                <div
                  className="product__item-footer "
                  style={{ alignItems: 'start', flexDirection: 'column' }}
                >
                  <div className="product__item-price">
                    <h6 className="fs-sm fw-medium mb-0">
                      {Number(product?.sale_price || product?.price).toFixed(2)}
                    </h6>
                    {product?.price && (
                      <span className="fs-sm">
                        <del>{product?.price}</del>
                      </span>
                    )}
                  </div>
                  <div className="product__item-action">
                    <CartButton product={product} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}

      <div className="col-12">
        <div className="product-listing__more text-center">
          <Link
            href={`${categoryUrl && sliceRoute(categoryUrl)}`}
            className="trk-btn trk-btn--outline mt-3"
          >
            View All Products
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ProductListingCard;
